var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('i',{class:`service__icon sm rhg-font-icon--${_vm.service.code}`}),_c('span',{staticClass:"service__name"},[_vm._v(_vm._s(_vm.service.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }